import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { EntityType } from '@beefco/types/bridge';
import { AggregatedEventCenter, NodeRegistry } from "../misc";
import { ComponentDragSourceHandler, NodeDragSourceHandler, NodeDragTargetHandler, NodeSelectionHandler } from "./handlers";
import { DragState, NodeRectObserver, SelectionState } from "./emitters";
import { SidebarDragTargetHandler } from "./handlers/SidebarDragTargetHandler";

/**
 * Keeps track of Dnd-sensitive elements:
 * Nodes, Screen, Blocks and all the events between them
 */
export var Bridge = /*#__PURE__*/function () {
  /** bridging brokers */
  // FIXME: remove all the params
  function Bridge(frameBroker, wsClientBroker, bus) {
    var _this$eventCenters;
    _classCallCheck(this, Bridge);
    this.frameBroker = frameBroker;
    this.wsClientBroker = wsClientBroker;
    this.bus = bus;
    /** state emitters */
    // @ts-expect-error assigned before definition
    _defineProperty(this, "dragState", new DragState(this.bus));
    // @ts-expect-error assigned before definition
    _defineProperty(this, "selectionState", new SelectionState(this.bus));
    _defineProperty(this, "nodeRectObserver", void 0);
    /** registries */
    _defineProperty(this, "nodeRegistry", new NodeRegistry());
    _defineProperty(this, "eventCenters", void 0);
    this.nodeRectObserver = new NodeRectObserver(this.bus, this.nodeRegistry);
    var nodeEventCenter = new AggregatedEventCenter();
    nodeEventCenter.addHandler(new NodeDragSourceHandler(this.dragState));
    nodeEventCenter.addHandler(new NodeDragTargetHandler(this.dragState, this.nodeRegistry));
    nodeEventCenter.addHandler(new NodeSelectionHandler(this.selectionState, this.dragState));
    var componentEventCenter = new AggregatedEventCenter();
    componentEventCenter.addHandler(new ComponentDragSourceHandler(this.dragState));
    var windowEventCenter = new AggregatedEventCenter();
    windowEventCenter.addHandler(new SidebarDragTargetHandler(this.dragState));
    this.eventCenters = (_this$eventCenters = {}, _defineProperty(_this$eventCenters, EntityType.NODE, nodeEventCenter), _defineProperty(_this$eventCenters, EntityType.COMPONENT, componentEventCenter), _defineProperty(_this$eventCenters, EntityType.WINDOW, windowEventCenter), _this$eventCenters);
  }
  _createClass(Bridge, [{
    key: "register",
    value: function register(originType, domNode, payload) {
      if (!domNode) return;
      if (originType === EntityType.NODE) {
        this.nodeRegistry.register(domNode, payload);
      }
      this.eventCenters[originType].connect(domNode, payload);
    }
  }, {
    key: "unregister",
    value: function unregister(originType, domNode) {
      if (!domNode) return;
      if (originType === EntityType.NODE) {
        this.nodeRegistry.unregister(domNode);
      }
      this.eventCenters[originType].disconnect(domNode);
    }
  }]);
  return Bridge;
}();